import { Breadcrumbs, Typography } from '@mui/material';
import { useMemo } from 'react';
import { useNavigate } from 'react-router';
import {
  keywordResearchSubmenuTitles,
  paths
} from 'src/common/config/TextMessage';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { keywordResearchDashBoardCss } from 'src/content/keywordResearch/keywordResearchCSS';

interface BreadcrumbConfig {
  text: string;
  path?: string | (() => void);
  isActive?: boolean;
}

const ContentStrategyBreadcrumbs = () => {
  const navigate = useNavigate();

  const getBreadcrumbs = (): BreadcrumbConfig[] => {
    return [
      {
        text: 'Orbit AI',
        path: paths.orbitAiAgent
      },
      {
        text: keywordResearchSubmenuTitles.contentStrategy,
        path: paths.contentStrategy
      }
    ];
  };

  const breadcrumbs = useMemo(() => getBreadcrumbs(), []);

  const breadcrumbElements = breadcrumbs.map((crumb, index) => {
    const isLast = index === breadcrumbs.length - 1;
    const isActive = crumb.isActive !== undefined ? crumb.isActive : isLast;

    const handleClick = () => {
      if (crumb.path) {
        if (typeof crumb.path === 'function') {
          crumb.path();
        } else {
          navigate(crumb.path);
        }
      }
    };

    return (
      <Typography
        key={index}
        sx={{
          ...(isActive
            ? keywordResearchDashBoardCss?.breadCrumbText
            : keywordResearchDashBoardCss?.breadCrumbLightText),
          ...(!isActive && { cursor: 'pointer' })
        }}
        onClick={!isActive ? handleClick : undefined}
      >
        {crumb.text}
      </Typography>
    );
  });

  return (
    <Breadcrumbs
      separator={
        <NavigateNextIcon
          fontSize="small"
          sx={keywordResearchDashBoardCss?.navigateNextIcon}
        />
      }
      aria-label="breadcrumb"
    >
      {breadcrumbElements}
    </Breadcrumbs>
  );
};

export default ContentStrategyBreadcrumbs;
